import ListaFactura from "../componentes/ListaFactura.vue";
import RegistrarFactura from "../componentes/RegistrarFactura.vue";
import ListaPendienteFactura from "../componentes/ListaPendienteFactura.vue";
const routes = [
    ...route(`/lista-facturas`, ListaFactura, {
        name: "facturas",
        tipo: 1,
        Auth: true,
    }),
    ...route(`/lista-facturas-pendientes`, ListaPendienteFactura, {
        name: "facturas",
        tipo: 1,
        Auth: true,
    }),
    ...route(`/lista-facturas-pro`, ListaFactura, {
        name: "pro-factura",
        tipo: 2,
        Auth: true,
    }),
    ...route(`/registrr-facturas`, RegistrarFactura, {
        name: "facturas",
        form: "registrr-facturas",
        tipo: 1,
        Auth: true,
    }),
    ...route(`/registrr-facturas-pro`, RegistrarFactura, {
        name: "pro-factura",
        form: "registrr-facturas-pro",
        tipo: 2,
        Auth: true,
    }),
];

function route(path, component = Default, meta = {}) {
    return [
        {
            path,
            component,
            meta,
        },
    ];
}

export default routes;
